import { AuthInlineWidget } from '../components/AuthInlineWidget';

export function LoginPage() {
  return <AuthInlineWidget layout="page" defaultView="login" />;
}
